<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="text-center mb-5">
            <img src="/img/brand/logo-login.png" height="74" />
          </div>

          <b-card class="p-4">
            <b-form v-loading="loading" @submit.prevent="resetPassword()">
              <h1>Password Reset</h1>
              <p class="text-muted">Enter your email address below to reset your password</p>
              <b-input-group class="mb-3">
                <b-input-group-prepend><b-input-group-text><i class="icon-envelope"></i></b-input-group-text></b-input-group-prepend>
                <b-form-input v-model="username" type="text" class="form-control" placeholder="Email Address" autocomplete="username email" />
              </b-input-group>
              <b-alert :show="!!error" fade variant="danger">{{error}}</b-alert>
              <b-row>
                <b-col cols="6">
                  <b-button variant="primary" type="submit" class="px-4">Reset Password</b-button>
                </b-col>
                <b-col cols="6" class="text-right">
                  <b-button variant="link" class="px-0" to="/login">Already a member?</b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Forgot',

  data(){
    return {
      username : '',

      // State
      loading : false,
      error   : '',
    }
  },

  methods: {
    resetPassword(){
      let { username } = this

      if( !username || username.trim().length === 0 ){
        this.error = "Please enter your email address"
        return
      }

      // Prevent duplicate submit
      const $focus = document.querySelector(":focus")
      $focus && $focus.blur()

      if( this.loading ){
        return
      }

      this.loading = true
      this.error = ''

      this.$API.v2.Users.ForgotPassword(username)
      .then(() => {
        this.$router.push({
          path: '/login',
          query: {
            reset : 1,
          }
        })
      })
      .catch((err) => {
        this.loading = false
        this.error = err
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.app {
  background: #2f353d;
}
</style>
